import React from "react";
import "./Home.css";
import { useNavigate } from "react-router-dom";
import NewsTicker from "../NewsTicker/NewsItem";
import ContactPage from "../ContactPage/ContactPage";
import Seo from "../Seo/Seo";
import { siteConfig } from "../../config/site";
import { useIsDanish } from "../../i18n/LanguageContext";
import softdev from "../../assets/images/softdev.png";
import azure2 from "../../assets/images/azure-img.png";
import auto from "../../assets/images/auto.png";

const services = [
  {
    img: softdev,
    title: "Software Development",
    tag: "Development",
    hook: "Internal tools, APIs, or customer portals are fragile, manual, or hard to change?",
    text: "We build reliable web apps, backends, integrations, and complex systems around how your people actually work.",
    outcomes: ["Custom-fit, not off-the-shelf", "Ships in weeks, not years", "Scales as you grow"],
    link: "/services/software-development",
  },
  {
    img: azure2,
    title: "Microsoft Azure Services",
    tag: "Cloud",
    hook: "Need to move, run, or modernise workloads in cloud without losing control?",
    text: "Plan, migrate, and operate cloud environments with security, cost control, and governance built in.",
    outcomes: ["Cut infrastructure costs", "99.9% uptime", "Migrate with zero data loss"],
    link: "/services/azure",
  },
  {
    img: auto,
    title: "Automation",
    tag: "Automation",
    hook: "Repeating approvals, reports, access changes, or data movement every week?",
    text: "We automate the busywork so your people spend less time copying, chasing, checking, and fixing.",
    outcomes: ["Save hours every week", "Fewer human errors", "Works 24/7"],
    link: "/services/automation",
  },
  {
    img: auto,
    title: "AI Automation",
    tag: "AI",
    hook: "Want AI assistants or bots connected to your data, but private and governed?",
    text: "Practical AI that reads documents, answers users, and supports decisions without exposing sensitive data.",
    outcomes: ["Automate complex decisions", "Learns and improves", "Real ROI, measurable"],
    link: "/services/ai-automation",
  },
  {
    img: auto,
    title: "AI Governance",
    tag: "Governance",
    hook: "People are already using AI, but you cannot prove what data it sees?",
    text: "Enforce AI governance through the Microsoft platform — Purview, Entra ID, Content Safety, and Azure Policy — so AI stays safe, compliant, and auditable.",
    outcomes: ["Control who uses AI & how", "Stop data leaking into AI", "Audit every AI interaction"],
    link: "/services/ai-governance",
  },
  {
    img: azure2,
    title: "Azure Governance",
    tag: "Cloud",
    hook: "Cloud resources exist, but access, cost ownership, and standards are inconsistent?",
    text: "Stay secure, compliant, and in control with clear policies, cost limits, and visibility across every resource.",
    outcomes: ["Enforce security & compliance", "Stop surprise cloud bills", "Full audit visibility"],
    link: "/services/azure-cloud",
  },
];

const stats = [
  { value: "50+", label: "Clients Supported" },
  { value: "200+", label: "Projects Contributed To" },
  { value: "99%", label: "Client Satisfaction" },
  { value: "10+", label: "Years Founder Experience" },
];

const servicesDa = [
  {
    img: softdev,
    title: "Softwareudvikling",
    tag: "Udvikling",
    hook: "Er jeres interne værktøjer, API'er eller kundeportaler skrøbelige, manuelle eller svære at ændre?",
    text: "Vi bygger webapps, backends, integrationer og komplekse systemer omkring den måde jeres mennesker faktisk arbejder på.",
    outcomes: ["Tilpasset jeres arbejdsgange", "Leveret via CI/CD", "Bygget til drift og videreudvikling"],
    link: "/services/software-development",
  },
  {
    img: azure2,
    title: "Microsoft Azure Services",
    tag: "Cloud",
    hook: "Skal I flytte, drive eller modernisere workloads i cloud uden at miste kontrollen?",
    text: "Vi planlægger, migrerer og driver cloudmiljøer med sikkerhed, cost control og governance indbygget fra start.",
    outcomes: ["Kontrollerede cloudomkostninger", "Mindre driftsrisiko", "Migrering med styr på data"],
    link: "/services/azure",
  },
  {
    img: auto,
    title: "Automatisering",
    tag: "Automation",
    hook: "Gentager jeres team godkendelser, rapporter, adgangsændringer eller dataflytning hver uge?",
    text: "Vi automatiserer det manuelle arbejde, så jeres folk bruger mindre tid på at kopiere, rykke, kontrollere og rette.",
    outcomes: ["Spar timer hver uge", "Færre manuelle fejl", "Processer der kører stabilt"],
    link: "/services/automation",
  },
  {
    img: auto,
    title: "AI Automation",
    tag: "AI",
    hook: "Vil I have AI-assistenter eller bots koblet på jeres data, men stadig privat og styret?",
    text: "Praktisk AI der læser dokumenter, svarer brugere og understøtter beslutninger uden at eksponere følsomme data.",
    outcomes: ["AI med adgangskontrol", "Bygget på jeres data", "Målbar praktisk værdi"],
    link: "/services/ai-automation",
  },
  {
    img: auto,
    title: "AI Governance",
    tag: "Governance",
    hook: "Bruger folk allerede AI, uden at I kan bevise hvilke data den ser?",
    text: "Vi etablerer AI governance med Microsoft Purview, Entra ID, Content Safety og Azure Policy, så AI forbliver sikker, compliant og auditerbar.",
    outcomes: ["Styr hvem der bruger AI", "Beskyt data mod læk", "Audit på AI-aktivitet"],
    link: "/services/ai-governance",
  },
  {
    img: azure2,
    title: "Azure Governance",
    tag: "Cloud",
    hook: "Findes cloudressourcerne allerede, men adgang, ejerskab og standarder er inkonsistente?",
    text: "Få sikkerhed, compliance og kontrol med tydelige policies, cost limits og synlighed på tværs af ressourcer.",
    outcomes: ["Håndhæv sikkerhed og compliance", "Undgå overraskende cloudregninger", "Fuld audit-synlighed"],
    link: "/services/azure-cloud",
  },
];

const statsDa = [
  { value: "50+", label: "Kunder understøttet" },
  { value: "200+", label: "Projekter bidraget til" },
  { value: "99%", label: "Kundetilfredshed" },
  { value: "10+", label: "Års founder-erfaring" },
];

const faqItems = [
  {
    q: "Do you work only with Microsoft technologies?",
    a: "Yes. We focus on Microsoft Azure, Entra ID, Microsoft 365, Power Platform, and Azure DevOps to keep architecture coherent and governance enforceable.",
  },
  {
    q: "How do you handle security and compliance?",
    a: "We follow Zero Trust principles and align delivery with Microsoft Cloud Adoption Framework guidance, using policy-as-code, least privilege, and full audit trails.",
  },
  {
    q: "Can you help with both strategy and implementation?",
    a: "Yes. We run advisory workshops, implementation projects, and managed operations for teams that need ongoing governance and support.",
  },
];

const faqItemsDa = [
  {
    q: "Arbejder I kun i Microsoft-miljøer?",
    a: "Nej. Microsoft er et af vores stærkeste områder, men vi starter altid med jeres virkelighed: eksisterende tenants, værktøjer, API'er, dataflows og systemer. Løsningen skal passe til det miljø, I faktisk driver.",
  },
  {
    q: "Hvordan håndterer I sikkerhed og compliance?",
    a: "Vi arbejder efter Zero Trust-principper, least privilege, policy-as-code hvor det giver mening, og dokumenterbare audit trails.",
  },
  {
    q: "Kan I hjælpe med både strategi og implementering?",
    a: "Ja. Vi kan hjælpe med rådgivning, konkret implementering og løbende drift/governance, afhængigt af hvor jeres team har brug for støtte.",
  },
];

const whoWeHelp = [
  {
    title: "Companies moving to cloud",
    text: "You are leaving servers, old hosting, or fragmented infrastructure behind and need a safe path into cloud without losing control.",
  },
  {
    title: "Teams already operating in cloud",
    text: "You already have cloud resources, tenants, identities, tools, and workloads, but need better governance, visibility, security, or cost control.",
  },
  {
    title: "Organisations with complex integrations",
    text: "Your APIs, SaaS tools, internal systems, and business applications need to talk to each other reliably and securely.",
  },
  {
    title: "Businesses adopting AI or automation",
    text: "You want AI, bots, workflows, or automation, but need data protection, access control, audit trails, and practical operating rules.",
  },
];

const trustSignals = [
  "Danish company with CVR registration",
  "Confidential client delivery patterns",
  "Infrastructure-as-code first where possible",
  "Tenant-aware delivery using your existing tools",
  "Security, identity, and auditability built in",
  "No click-ops as the long-term operating model",
];

const whoWeHelpDa = [
  {
    title: "Virksomheder på vej i cloud",
    text: "I forlader servere, gammel hosting eller fragmenteret infrastruktur og har brug for en sikker vej til cloud uden at miste kontrollen.",
  },
  {
    title: "Teams der allerede er i cloud",
    text: "I har allerede cloudressourcer, tenants, identiteter, værktøjer og workloads, men har brug for bedre governance, synlighed, sikkerhed eller cost control.",
  },
  {
    title: "Organisationer med komplekse integrationer",
    text: "Jeres API'er, SaaS-værktøjer, interne systemer og forretningsapplikationer skal tale sammen pålideligt og sikkert.",
  },
  {
    title: "Virksomheder der indfører AI eller automation",
    text: "I vil bruge AI, bots, workflows eller automation, men har brug for databeskyttelse, adgangskontrol, audit trails og praktiske driftsregler.",
  },
];

const trustSignalsDa = [
  "Dansk virksomhed med CVR-registrering",
  "Fortrolige leverancemønstre fra kundeprojekter",
  "Infrastructure-as-code først hvor det giver mening",
  "Tenant-aware levering med jeres eksisterende værktøjer",
  "Sikkerhed, identitet og auditability indbygget",
  "No click-ops som langsigtet driftsmodel",
];

const Home = () => {
  const isDa = useIsDanish();
  const navigate = useNavigate();
  const currentServices = isDa ? servicesDa : services;
  const currentStats = isDa ? statsDa : stats;
  const currentFaqItems = isDa ? faqItemsDa : faqItems;
  const currentWhoWeHelp = isDa ? whoWeHelpDa : whoWeHelp;
  const currentTrustSignals = isDa ? trustSignalsDa : trustSignals;

  const homeSchema = [
    {
      "@context": "https://schema.org",
      "@type": "Organization",
      name: siteConfig.name,
      url: siteConfig.baseUrl,
      email: siteConfig.email,
      telephone: siteConfig.phoneDisplay,
      sameAs: [siteConfig.linkedinUrl],
      areaServed: "Europe",
    },
    {
      "@context": "https://schema.org",
      "@type": "WebSite",
      name: siteConfig.name,
      url: siteConfig.baseUrl,
      inLanguage: isDa ? "da" : "en",
    },
    {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: currentFaqItems.map((item) => ({
        "@type": "Question",
        name: item.q,
        acceptedAnswer: {
          "@type": "Answer",
          text: item.a,
        },
      })),
    },
  ];

  const scrollToContact = () => {
    document.getElementById("contact-section")?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div className="home-root">
      <Seo
        title={isDa ? "System32 | Cloud, integrationer, governance og modernisering" : "System32 | Microsoft Azure, Governance, and Modernisation"}
        description={isDa ? "Konsulenthus for cloud governance, integrationer, API'er, automatisering, AI governance og modernisering af komplekse systemer." : "Microsoft-first consultancy for Azure governance, Entra ID, CI/CD, AI governance, and cloud modernisation. Zero Trust and Microsoft CAF aligned delivery."}
        canonical={siteConfig.url("/")}
        type="website"
        schema={homeSchema}
      />

      {/* ── Hero ── */}
      <section className="hero">

        {/* Left panel */}
        <div className="hero-side hero-side--left">
          <div className="hero-feature-card">
            <span className="hero-feature-icon">🛡️</span>
            <div>
              <h4>Azure Governance</h4>
              <p>Policy enforcement, cost controls, and compliance built into every deployment.</p>
            </div>
          </div>
          <div className="hero-feature-card">
            <span className="hero-feature-icon">🔐</span>
            <div>
              <h4>Security & Identity</h4>
              <p>Zero-trust architecture with Microsoft Entra ID and role-based access control.</p>
            </div>
          </div>
          <div className="hero-feature-card">
            <span className="hero-feature-icon">☁️</span>
            <div>
              <h4>Cloud Migration</h4>
              <p>Seamless lift-and-shift or full modernisation to Azure — on your timeline.</p>
            </div>
          </div>
        </div>

        {/* Centre content */}
        <div className="hero-inner">
          <span className="hero-eyebrow">{isDa ? "Cloud, governance og integrationer" : "Microsoft-First Consultancy"}</span>
          <h1 className="hero-title">
            {isDa ? <>Digitale løsninger.<br />Én platform.</> : <>Digital Solutions.<br />One Platform.</>}
          </h1>
          <p className="hero-sub">
            {isDa
              ? "Vi designer, bygger og styrer jeres digitale teknologistak, så cloud, identitet, API'er, systemer og automation hænger sammen, kan auditeres, og intet efterlades på håb og portal clicks."
              : "We design and govern your entire digital technology stack on Microsoft — Azure, Entra ID, and Microsoft 365 — so everything connects, everything is auditable, and nothing is left running on a prayer and a portal click."}
          </p>
          <div className="hero-actions">
            <button className="btn-primary" onClick={scrollToContact}>
              {isDa ? "Book en strategisamtale" : "Book a strategy call"}
            </button>
            <button className="btn-outline" onClick={() => navigate("/use-cases")}>
              {isDa ? "Se cases" : "View use cases"}
            </button>
          </div>
        </div>

        {/* Right panel */}
        <div className="hero-side hero-side--right">
          <div className="hero-feature-card">
            <span className="hero-feature-icon">🤖</span>
            <div>
              <h4>AI & Automation</h4>
              <p>Intelligent workflows powered by Azure AI, Logic Apps, and custom ML models.</p>
            </div>
          </div>
          <div className="hero-feature-card">
            <span className="hero-feature-icon">⚙️</span>
            <div>
              <h4>DevOps & CI/CD</h4>
              <p>Azure DevOps pipelines that ship faster, safer, and with full auditability.</p>
            </div>
          </div>
          <div className="hero-feature-card">
            <span className="hero-feature-icon">📊</span>
            <div>
              <h4>Data & Analytics</h4>
              <p>Turn raw data into decisions with Azure Synapse, Power BI, and real-time insights.</p>
            </div>
          </div>
        </div>

      </section>

      {/* ── Scrolling capabilities ticker ── */}
      <NewsTicker />

      {/* ── Microsoft ecosystem strip ── */}
      <section className="ms-ecosystem">
        <p className="ms-ecosystem-label">{isDa ? "Vi bygger blandt andet på" : "Everything we deliver runs on"}</p>
        <div className="ms-ecosystem-pills">
          {["Microsoft Azure","Entra ID","Microsoft 365","Azure DevOps","Microsoft Purview","Power Platform","Azure AI"].map(p => (
            <span className="ms-pill" key={p}>{p}</span>
          ))}
        </div>
        <p className="ms-ecosystem-note">
          {isDa
            ? "Vi arbejder med jeres eksisterende tenant, værktøjer og platforme, men holder arkitekturen samlet: tydelig identitet, audit trail og governance der kan holde i drift."
            : "We work exclusively on the Microsoft platform — not a mix of vendors, not best-of-breed sprawl. One stack means one identity layer, one audit trail, and governance that actually holds."}
        </p>
      </section>

      {/* ── Stats strip ── */}
      <section className="stats-strip">
        {currentStats.map((s, i) => (
          <div className="stat-item" key={i}>
            <span className="stat-value">{s.value}</span>
            <span className="stat-label">{s.label}</span>
          </div>
        ))}
      </section>

      <section className="who-help-section">
        <div className="who-help-header">
          <span className="section-eyebrow">{isDa ? "Hvem vi hjælper" : "Who We Help"}</span>
          <h2>{isDa ? "For teams på vej i cloud, allerede i cloud eller fanget mellem systemer" : "For teams moving to cloud, already in cloud, or stuck between systems"}</h2>
          <p>
            {isDa ? "System32 er stærkest dér, hvor software, infrastruktur, identitet, API'er, automation og governance overlapper." : "System32 works best where software, infrastructure, identity, APIs, automation, and governance overlap."}
          </p>
        </div>
        <div className="who-help-grid">
          {currentWhoWeHelp.map((item) => (
            <article className="who-help-card" key={item.title}>
              <h3>{item.title}</h3>
              <p>{item.text}</p>
            </article>
          ))}
        </div>
      </section>

      <section className="trust-proof-section">
        <div className="trust-proof-inner">
          <div className="trust-proof-copy">
            <span className="section-eyebrow">{isDa ? "Sådan arbejder vi" : "How We Work"}</span>
            <h2>{isDa ? "Bygget til miljøer hvor fejl er dyre" : "Built for environments where mistakes are expensive"}</h2>
            <p>
              {isDa ? "Vi passer bedst til projekter, hvor løsningen rører rigtige driftssystemer: tenant-adgang, API'er, cloudressourcer, forretningsapplikationer, compliancekrav og ansvar for at tingene virker efter go-live." : "We are a good fit when the project touches real operating systems: tenant access, APIs, cloud resources, business applications, compliance requirements, and responsibility for keeping things working after go-live."}
            </p>
          </div>
          <div className="trust-proof-list">
            {currentTrustSignals.map((signal) => (
              <span key={signal}>{signal}</span>
            ))}
          </div>
        </div>
      </section>

      <section className="conversion-flow">
        <div className="conversion-flow-header">
          <span className="section-eyebrow">{isDa ? "Sådan starter vi" : "How We Start"}</span>
          <h2>{isDa ? "Fra første samtale til eksekverbar plan i fire trin" : "From first call to executable plan in four steps"}</h2>
        </div>
        <div className="conversion-steps">
          {[
            ...(isDa
              ? [
                  "Projekttype: migration, governance, AI eller DevOps",
                  "Hastighed og driftsmæssige rammer",
                  "Sikkerheds- og compliancekrav",
                  "Eksekveringsplan med ejere og milepæle",
                ]
              : [
                  "Project type: Migration, Governance, AI, or DevOps",
                  "Urgency and operating constraints",
                  "Security and compliance requirements",
                  "Execution roadmap with owners and milestones",
                ]),
          ].map((step, idx) => (
            <div className="conversion-step" key={step}>
              <span>{idx + 1}</span>
              <p>{step}</p>
            </div>
          ))}
        </div>
        <div className="conversion-flow-actions">
          <button className="btn-primary" onClick={scrollToContact}>{isDa ? "Book en strategisamtale" : "Book a strategy call"}</button>
          <button className="btn-outline btn-outline--dark" onClick={() => navigate("/use-cases")}>{isDa ? "Se cases" : "View use cases"}</button>
        </div>
      </section>

      <section className="engagement-section">
        <div className="engagement-header">
          <span className="section-eyebrow">{isDa ? "Samarbejdsmodel" : "Engagement Model"}</span>
          <h2>{isDa ? "Rådgivning, implementering og løbende drift" : "Advisory, implementation, and managed operations"}</h2>
          <p>{isDa ? "Start dér hvor I har brug for støtte nu, og byg videre mod en langsigtet driftsmodel." : "Start where you need support now, then scale into a long-term operating model."}</p>
        </div>
        <div className="handover-card">
          <span className="handover-label">{isDa ? "Vi bygger med jer og overdrager ordentligt" : "Build with you, hand over properly"}</span>
          <p>
            {isDa
              ? "Vi leverer ikke bare og forsvinder. Vi bygger sammen med jeres team, løfter deres kompetencer, dokumenterer beslutningerne og overdrager systemer, som jeres folk trygt kan drifte, udvide og styre."
              : "We do not just deliver and disappear. We build with your team, lift their capability, document the decisions, and hand over systems your people can operate, extend, and govern with confidence."}
          </p>
        </div>
        <div className="engagement-grid">
          <article className="engagement-card">
            <h3>{isDa ? "Rådgivning" : "Advisory"}</h3>
            <p>{isDa ? "Arkitekturgennemgang, governance baseline, platformstrategi og leveranceplanlægning." : "Architecture reviews, governance baseline, platform strategy, and delivery planning."}</p>
          </article>
          <article className="engagement-card">
            <h3>{isDa ? "Implementering" : "Implementation"}</h3>
            <p>{isDa ? "Landing zones, workload migration, CI/CD, identity governance og platform hardening." : "Landing zones, workload migration, CI/CD, identity governance, and platform hardening."}</p>
          </article>
          <article className="engagement-card">
            <h3>{isDa ? "Løbende drift" : "Managed"}</h3>
            <p>{isDa ? "Løbende policy-drift, access lifecycle governance, observability og compliance-rapportering." : "Ongoing policy operations, access lifecycle governance, observability, and compliance reporting."}</p>
          </article>
        </div>
        <div className="framework-strip">
          <span>{isDa ? "Zero Trust-aligned" : "Zero Trust aligned"}</span>
          <span>{isDa ? "Cloud Adoption Framework-aligned" : "Microsoft Cloud Adoption Framework aligned"}</span>
          <span>{isDa ? "Policy-as-code hvor det giver mening" : "Policy-as-code enforced"}</span>
          <span>{isDa ? "Auditerbart som standard" : "Auditable by default"}</span>
        </div>
      </section>

      {/* ── Services ── */}
      <div className="services-wrapper">
        <section className="services-section">
          <div className="services-header">
            <span className="section-eyebrow">{isDa ? "Hvad vi laver" : "What We Do"}</span>
            <h2 className="section-title">{isDa ? "Reelle problemer. Reelle løsninger." : "Real Problems. Real Solutions."}</h2>
            <p className="section-sub">
              {isDa ? "Uanset om I moderniserer eksisterende systemer eller bygger noget nyt, hjælper vi jer sikkert videre." : "Whether you're modernising legacy systems or building something new — here's how we help you move forward."}
            </p>
          </div>

          <div className="noclick-banner">
            <div className="noclick-banner-questions">
              <span>{isDa ? "🖱️ Klikker jeres admins ressourcer frem uden sporbarhed på hvad der blev bygget og hvorfor?" : "🖱️ Are your admins clicking resources into existence with no record of what was built or why?"}</span>
              <span>{isDa ? "🔓 Kører I AI-værktøjer uden policies for adgang og data?" : "🔓 Running AI tools with no policy on who can access them or what data they can see?"}</span>
              <span>{isDa ? "💾 Hvis nogen slettede jeres Azure tenant i aften, kunne I genopbygge den fra kode?" : "💾 If someone deleted your Azure tenant tonight, could you rebuild it from code?"}</span>
            </div>
            <div className="noclick-banner-answer">
              <strong>{isDa ? "Alt vi bygger deployes som kode, styres fra dag ét og kan reproduceres." : "Everything we build is deployed as code, governed from day one, and fully reproducible."}</strong>
              <span>{isDa ? " Det er sådan en platform bør drives ordentligt." : " That's what working properly on Microsoft looks like."}</span>
            </div>
          </div>

          <div className="services-grid">
            {currentServices.map((svc, i) => (
              <div className="service-card" key={i} onClick={() => navigate(svc.link)}>
                <div className="service-card-img">
                  <img src={svc.img} alt={svc.title} />
                  <span className="service-tag">{svc.tag}</span>
                </div>
                <div className="service-card-body">
                  <p className="service-hook">{svc.hook}</p>
                  <h3>{svc.title}</h3>
                  <p className="service-desc">{svc.text}</p>
                  <ul className="service-outcomes">
                    {svc.outcomes.map((o, j) => (
                      <li key={j}>{o}</li>
                    ))}
                  </ul>
                  <span className="service-link">
                    {isDa ? "Læs mere" : "Learn More"} <span className="arrow">→</span>
                  </span>
                </div>
              </div>
            ))}
          </div>
        </section>
      </div>

      {/* ── Contact ── */}
      <div id="contact-section">
        <ContactPage />
      </div>

      <section className="faq-section">
        <div className="faq-header">
          <span className="section-eyebrow">FAQ</span>
          <h2>{isDa ? "Svar før vi mødes" : "Answers before we even meet"}</h2>
        </div>
        <div className="faq-grid">
          {currentFaqItems.map((item) => (
            <article key={item.q} className="faq-item">
              <h3>{item.q}</h3>
              <p>{item.a}</p>
            </article>
          ))}
        </div>
      </section>

    </div>
  );
};

export default Home;
